export default "__VITE_ASSET__BCQ_GWca__"